import SpeakerFull from './SpeakerFull'

export default SpeakerFull
// eslint-disable-next-line import/export
export * from './SpeakerFull'
